import { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from './drawer'
import { Name } from './style'
import SearchIcon from '@mui/icons-material/Search'
import {Box, Input} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear'
import {useTranslation} from "react-i18next";
import NoticeModal from './notice'

export default function Menu(props) {
  const { t } = useTranslation('translation', { keyPrefix: 'dashboard' })
  const selfUser = JSON.parse(localStorage.getItem('user'))

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false)
  }

  const [openSearch, setOpenSearch] = useState(!!localStorage.getItem('search'));
  const handleCloseSearch = () => {
    props.handleSearchUser('')
    setOpenSearch(false)
  }

  const [name, setName] = useState('');
  const [openNoticeModal, setNoticeModal] = useState(false);
  const [notice, setNotice] = useState('');
  useEffect(() => {
    const meta = JSON.parse(localStorage.getItem('metadata'))
    setName(meta?.website_title)
    if (meta?.notice) {
      setNotice(meta.notice)
      setNoticeModal(true)
    }
  }, [])

  const handleCloseNoticeModal = () => {
    setNoticeModal(false)

    const meta = JSON.parse(localStorage.getItem('metadata'))
    localStorage.setItem('metadata', JSON.stringify({...meta, notice: ''}))
  }

  return (
    <AppBar position="static">
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2, margin: 0, padding: 0 }}
          onClick={() => setOpen(true)}
        >
          <MenuIcon />
        </IconButton>

        {!openSearch && selfUser.type === 'admin' && <IconButton
         size="large"
         edge="start"
         color="inherit"
         aria-label="menu"
         sx={{ml: 2, margin: 2, padding: 0}}
         onClick={() => setOpenSearch(true)}
        >
          <SearchIcon/>
        </IconButton>}
        {openSearch
          ?
            <Box sx={{ display: 'flex', alignItems: 'flex-end', m: 2 }}>
              <Input
               placeholder={t('search_user')}
               variant="standard"
               size='small'
               dir={'rtl'}
               sx={{color: 'white'}}
               value={localStorage.getItem('search')}
               onChange={(e) => props.handleSearchUser(e.target.value)} />
              <ClearIcon sx={{mr: 1, my: 0.5 }} onClick={handleCloseSearch} />
            </Box>
         : <Name>
           {name}
         </Name>
        }

      </Toolbar>
      <Drawer open={open} handleClose={handleClose} />
      <NoticeModal open={openNoticeModal} handleClose={handleCloseNoticeModal} content={notice} />
    </AppBar>
  );
}
